import { Button, Card, Space } from 'antd';
import AdminSidebar from '../Components/Sidebar';
import TableComponent from '../Components/TableComponent';
import { getSubServices } from '../redux/slices/servicesSlice';
import { useNavigate, useParams } from 'react-router';
import { useState } from 'react';
import { PlusCircleOutlined, ReloadOutlined } from '@ant-design/icons';

function SubServices() {
    const { id } = useParams()
    const navigate = useNavigate();
    const [serviceName, setServiceName] = useState()
    const callbackFun = (name) => {
        setServiceName(name)
    }
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: "Specialized Service",
            dataIndex: 'specialized_service_id',
            key: 'specialized_service_id'
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
        },
        {
            title: 'Action',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (_, record) => <a onClick={() => viewData(record)}>Edit</a>,
        },
    ];

    const viewData = async ({ name, status, key }) => {
        navigate(`/admin/specialized_services/sub_services/${key}`, {
            state: {
                id: key,
                name,
                status,
                specialized_service_id: id
            }
        })
    }

    const createSubService = () => {
        navigate('/admin/specialized_services/sub_services/create', {
            state: { id }
        })
    }

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                    title="Sub Services"
                    style={{ marginBottom: 24 }}
                    extra={
                        <Space>
                            <Button icon={<PlusCircleOutlined />} onClick={createSubService}>
                                Create Sub Service
                            </Button>
                        </Space>
                    }
                >
                    <p>Specialized Service : {serviceName}</p>
                    <TableComponent
                        listData={getSubServices}
                        columns={columns}
                        placeholder="Search Sub Services..."
                        id={id}
                        callbackFun={callbackFun}
                    />
                </Card>
            } />
        </>
    );
}

export default SubServices;